<div class="card__wrapper">
	<div class="header__wrapper">
		<div class="flex gap-3 items-center">
			<div class="skeleton__wrapper p-2">
				<div class="w-5 h-5"></div>
			</div>

			<div class="h-6 skeleton__wrapper w-32"></div>
		</div>
	</div>

	<div class="border-b border"></div>

	<div class="flex items-baseline p-4">
		<div class="h-8 skeleton__wrapper w-28"></div>
		<div class="h-5 skeleton__wrapper w-16 ml-2"></div>
	</div>

	<div class="flex p-4 pt-0">
		<div class="h-5 skeleton__wrapper w-24"></div>
	</div>
</div>
